// AddButton.tsx   ← feel free to rename as needed
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icons } from '../../icons';

interface Props {
  to?: string;
  label: string;
  responsive?: boolean;
  collapsed?: boolean;
  onClick?: () => void;
}

const AddButton: React.FC<Props> = ({
  to,
  label,
  responsive = false,
  collapsed = false,
  onClick,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }

    if (to) {
      navigate(to);
    }
  };

  return (
    <button
      onClick={handleClick}
      type='button'
      className={`${
        collapsed
          ? 'p-1 h-[40px] w-[40px] rounded-full'
          : 'rounded-full p-1 w-full lg:h-[56px]'
      } flex items-center justify-center
         bg-[#FF0050] text-white py-4
         hover:bg-[#ff0051d7] transition-colors`}
    >
      <Icons.Plus className='h-6 w-6 lg:h-8 lg:w-8' fill='white' />

      {/* label only when sidebar open */}
      <span
        className={`${
          responsive && collapsed ? 'hidden' : ''
        } ml-2 text-[16px]`}
      >
        {label}
      </span>
    </button>
  );
};

export default AddButton;
